import {
  ReviewId,
  type RoundDomainSelectModel,
  RoundId,
  RoundUrn,
} from '@mntn-dev/domain-types'

import { MockModel } from './mock-model.ts'

export const MockRound = MockModel<RoundDomainSelectModel>(
  ({
    roundId = RoundId(),
    roundUrn = RoundUrn(roundId),
    reviewId = ReviewId(),
    roundNumber = 1,
    status = 'in_progress',
    proposal = {},
    feedback = {},
  }) => {
    return {
      roundId,
      roundUrn,
      reviewId,
      roundNumber,
      status,
      proposal,
      feedback,
    } satisfies RoundDomainSelectModel
  }
)
